import { render, staticRenderFns } from "./message-large-stream.vue?vue&type=template&id=5459f85e&scoped=true"
import script from "./message-large-stream.vue?vue&type=script&lang=ts"
export * from "./message-large-stream.vue?vue&type=script&lang=ts"
import style0 from "./message-large-stream.vue?vue&type=style&index=0&id=5459f85e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5459f85e",
  null
  
)

export default component.exports